export default "__VITE_ASSET__P989ZVYV__"